import axios from "axios";
import secureAxios from "./secureAxios";
const API_BASE_URL = import.meta.env.VITE_BACKEND_API_URL;

export async function payoutInitiate(formData, token, selectedUser) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/payout/direct/${selectedUser}`,
      formData,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function payoutInitiateDash(formData, token) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/payout/initiate/dashboard`,
      formData,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getExcelDataReport(
  token,
  startDate,
  endDate,
  typeData,
  typeDate,
  orgName,
  user,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = {
      startDate,
      endDate,
      type: typeData,
      typeDate,
      orgName,
      userId: user,
    };
    let response;
    // if (orgName === undefined) {
    //   response = await axios.get(
    //     API_BASE_URL +
    //     `/v1/admin/transactions/get-transaction-excel?startDate=${startDate}&&endDate=${endDate}&&type=${typeData}&&typeDate=${typeDate}`,
    //     { headers }
    //   );
    // }
    // else if (user) {
    //   response = await axios.get(
    //     API_BASE_URL +
    //     `/v1/admin/transactions/get-transaction-excel?startDate=${startDate}&&endDate=${endDate}&&type=${typeData}&&typeDate=${typeDate}&userId=${user}`,
    //     { headers }
    //   );
    // }
    // else {

    // }
    response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/get-transaction-excel`,
      { headers, params }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function statisticByMonth(token) { //!Not working in prod
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(
      API_BASE_URL + `/v1/admin/transactions/statistic-by-month`,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getStatistics(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/statistics`,
      { headers, params: { startDate, endDate } }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function payinStatus(data) {
  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/payments/status?isLookup=true`,
      data,
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error; // Re-throw the error if needed
  }
}
export async function payinStatusInternal(data) {
  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/payments/internal-status?isLookup=true`,
      data,
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error; // Re-throw the error if needed
  }
}
export async function payoutStatus(data) {
  const headers = {
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/payout/status`,
      data,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
export async function payoutStatusInternal(data) {
  const headers = {
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/payout/internal-status`,
      data,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getTransactionThroughOrderId(token, orderId) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-transaction-by-id`,
      {
        headers,
        params: { orderId },
      }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getDataForExcel(
  token,
  startDate,
  endDate,
  typeData,
  transactionStatus,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const params = { startDate, endDate, type: typeData, transactionStatus };
    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/get-transactions-for-status`,
      { headers, params }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function merchantManagement(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/merch-management`,
      { headers, params }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function adminBalanceData(token) { //!Not in use on prod
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(
      API_BASE_URL + `/v1/admin/transactions/admin-balance`,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getRollingReserve(token, page) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { page };
    const response = await secureAxios.get(
      API_BASE_URL +
      `/v1/rolling-reserve/get-rolling-reserve-data`,
      { headers, params },
    );
    return response;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getAdminCommData(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/admin-comm`,
      { headers, params }
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getRollingReserveSettlement(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      API_BASE_URL +
      `/v1/rolling-reserve/get-rolling-reserve-settlements`,
      { headers, params },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function sendCsv(token, data) { //!Not in use on prod
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/admin/transactions/send-status-through-csv`,
      data,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getInvoice(token, transactionID, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const params = { transactionID, startDate, endDate };
    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/get-invoice-pdf`,
      { headers, params },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getAllUsers(token, page) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/admin/users?page=${page}`,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function createUser(formData, token) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/admin/users/create`,
      formData,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.error("Error creating new user:", error.message);
    throw error;
  }
}

export async function createMerchantUser(formData, token) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/admin/users/create-mops`,
      formData,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.error("Error creating admin user:", error.message);
    throw error;
  }
}

export async function getMerchantUsers(token, page=1) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/admin/users/get-merchant-users?page=${page}`,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getLatestTransactions(token) { //!Not in use on prod
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/admin/transactions/latest-transaction`,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw new err();
  }
}

export async function userBalanceData(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/balance`,
      { headers, params: {} },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function payinData(
  token,
  currentPage,
  startDate,
  endDate,
  orgName,
  bussinessName,
  selectedStatus,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const params = {
      page: currentPage,
      startDate: startDate || "",
      endDate: endDate || "",
      orgName: orgName || "",
      bussinessName: bussinessName || "",
      selectedStatus: selectedStatus || "",
    };

    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payin`,
      { headers, params },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function payoutData(
  token,
  currentPage,
  startDate,
  endDate,
  orgName,
  bussinessName,
  selectedStatus,
  mode,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const params = {
      page: currentPage,
      startDate: startDate || "",
      endDate: endDate || "",
      orgName: orgName || "",
      bussinessName: bussinessName || "",
      selectedStatus: selectedStatus || "",
      mode: mode || "",
    };
    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payout`,
      { headers, params },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getStatisticsPayin(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payin-statistics`,
      { headers, params },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error; // Re-throw the error if needed
  }
}

export async function getStatisticsPayout(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payout-statistics`,
      { headers, params },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error; // Re-throw the error if needed
  }
}

export async function getReconcilationTimeTxn(token, value) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await secureAxios.post(
      API_BASE_URL + `/v1/admin/transactions/get-reconcilation-time-txn`,
      value,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function rotateKey(token, userId) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.patch(
      API_BASE_URL + `/v1/admin/users/rotate/${userId}`,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function updateUserStatus(token, currentUser, status) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    await axios.patch(
      API_BASE_URL + `/v1/admin/users/${currentUser?.id}`,
      { status: status },
      { headers },
    );
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function updateVpaStatus(token, currentUser, Vpastatus) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    await axios.patch(
      API_BASE_URL + `/v1/admin/users/vpa/updateVpa`,
      { id: currentUser.id, validateVpa: Vpastatus },
      { headers },
    );
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export const UpdateAutoSwitch = async (token, payload) => {
  return axios.patch(
    `${API_BASE_URL}/v1/admin/users/swicth/updateSwitch`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export async function updateIpWhitelistStatus(token, currentUser, IpStatus) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    await axios.patch(
      API_BASE_URL + `/v1/admin/users/ip/update-whitelist-status`,
      { id: currentUser.id, IpStatus: IpStatus },
      { headers },
    );
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}


export const UpdateAutoSwitchPayout = async (token, payload) => {
  return axios.patch(
    `${API_BASE_URL}/v1/admin/users/swicth/updatePayoutSwitch`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export async function createRecon(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await secureAxios.post(
      API_BASE_URL + `/v1/reconciliation/create-reconcilation`,
      data,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getReconData(token, page = 1, startDate, endDate) {
  try {
    const params = { page };

    if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }

    const response = await secureAxios.get(
      API_BASE_URL + "/v1/reconciliation/get-reconciliation-data",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getWebhook(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(
      API_BASE_URL + `/v1/webhooks/get-webhook`,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getChangeStatus(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(
      API_BASE_URL + `/change-status/get-status-data`,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getChangeStatusById(token, id, page) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(
      API_BASE_URL + `/change-status/get-status-data?id=${id}&page=${page}`,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function login(email, password, recaptchaToken) {
  try {
    const response = await secureAxios.post(
      `${API_BASE_URL}/v1/admin/auth/login`,
      { email, password, recaptchaToken },
      {
        headers: { Authorization: undefined },
      },
    );

    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export async function refreshTokenApi(token) {
  try {
    if (token) {
      const response = await secureAxios.post(
        `${API_BASE_URL}/v1/admin/auth/refresh-token`,
        { refreshToken: token }
      );
      return response.data;
    }
  } catch (error) {
    console.log(error.message);
  }
}

export async function accessTokenApi(token) {
  try {
    if (token) {
      const response = await secureAxios.post(
        `${API_BASE_URL}/v1/admin/auth/access-token`,
        { refreshToken: token }
      );
      return response.data;
    }
  } catch (error) {
    console.log(error.message);
  }
}

export async function createWebhook(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    await axios.post(
      API_BASE_URL + `/v1/webhooks/create-webhook`,
      { data },
      { headers },
    );

    return;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function createBlockedUsers(data) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(API_BASE_URL + `/fraud-detection`, data, {
      headers,
    });

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getBlockedUsers(page, search) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      API_BASE_URL +
      `/fraud-detection/get-blocked-users?page=${page}&search=${search}`,
      {
        headers,
      },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getRawWebhooks(page, orderId, transactionId) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      API_BASE_URL +
      `/raw-webhook/get-all-webhook?page=${page}&orderId=${orderId}&transactionId=${transactionId}`,
      {
        headers,
      },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getChangePasswords(page, email) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      API_BASE_URL +
      `/change-password/get-change-passwords?page=${page}&email=${email}`,
      {
        headers,
      },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

// export async function generateNewToken(token) {
//   try {
//     const response = await secureAxios.post(
//       `${API_BASE_URL}/v1/admin/auth/refresh-token`,
//       { token },
//     );

//     return response.data;
//   } catch (err) {
//     console.log(err.message);
//     throw err;
//   }
// }

export async function getReconDashboardData(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/reconciliation/get-dashboard-data`,
      { headers, params: { startDate, endDate } }
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function addProvider(token, formData) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    await axios.post(`${API_BASE_URL}/v1/provider/add-provider`, formData, {
      headers,
    });
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getAllProviders(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const reponse = await axios.get(
      `${API_BASE_URL}/v1/provider/get-all-providers`,
      {
        headers,
      },
    );
    return reponse;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function checkProivderStatus(token, id) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const reponse = await axios.get(
      `${API_BASE_URL}/v1/provider/check-provider?id=${id}`,
      {
        headers,
      },
    );
    return reponse;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getProvider(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/provider/get-provider`,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function updateProviderRequest(token, providerId, formData) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.put(
      `${API_BASE_URL}/v1/provider/${providerId}`,
      formData,
      { headers },
    );

    return response;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function fetchAllProviders(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/provider/get-provider`,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
export async function getOrganisationDashboard(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/organisation/get-organisation`,
      { headers, params: {} }
    );

    return response.data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
}

export async function getOrganisation(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/organisation/get-organisation`,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
}

export const updateOrganisationDetails = async (id, payload, token) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/organisation/${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};

export async function getPayinByOrgName(token, orgName, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    let response;
    if (startDate === undefined) {
      const params = { orgName };
      response = await secureAxios.get(
        API_BASE_URL + `/v1/admin/transactions/payinByOrg`,
        {
          headers,
          params,
        }
      );
    } else {
      const params = { orgName, startDate, endDate };

      response = await secureAxios.get(
        API_BASE_URL + `/v1/admin/transactions/payinByOrg`,
        {
          headers,
          params,
        }
      );
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching pay-in statistics:", error.message);
    throw error;
  }
}

export async function getPayinByMerchId(token, merchId, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { merchId, startDate, endDate };
    let response;

    response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payin-by-merch`,
      { headers, params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pay-in statistics:", error.message);
    throw error;
  }
}

export async function getPayoutByMerchId(token, merchId, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { merchId, startDate, endDate };
    let response;

    response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payout-by-merch`,
      { headers, params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pay-in statistics:", error.message);
    throw error;
  }
}


export async function getPayoutByOrgName(token, orgName, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    let response;
    if (startDate === undefined) {
      const params = { orgName };
      response = await secureAxios.get(
        API_BASE_URL + `/v1/admin/transactions/payoutByOrg`,
        { headers, params },
      );
    } else {
      const params = { orgName, startDate, endDate };
      response = await secureAxios.get(
        API_BASE_URL + `/v1/admin/transactions/payoutByOrg`,
        { headers, params },
      );
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching payout statistics:", error.message);
    throw error;
  }
}

export async function getMonthlyTransactionById(id, startDate, endDate) {
  try {
    const params = { startDate, endDate, userId: id };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-monthly-transaction-by-id`,
      { params }
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function fetchOrgName(orgName, token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/organisation/get-organisation?orgName=${orgName}`,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function addOrganization(token, formData) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    await axios.post(
      `${API_BASE_URL}/v1/organisation/add-organisation`,
      formData,
      { headers },
    );
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
export async function getPayinByOrgAndPG(
  token,
  orgName,
  pg,
  startDate,
  endDate,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { orgName, pg, startDate, endDate };
    let response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payinByOrgAndPg`,
      { headers, params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pay-in statistics:", error.message);
    throw error;
  }
}

export async function getPayinByMerchAndPG(
  token,
  merchId,
  orgName,
  pg,
  startDate,
  endDate,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { merchId, orgName, pg, startDate, endDate };
    let response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payin-by-merch-pg`,
      { headers, params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pay-in statistics:", error.message);
    throw error;
  }
}

export async function getPayoutByMerchAndPG(
  token,
  merchId,
  orgName,
  pg,
  startDate,
  endDate,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { merchId, orgName, pg, startDate, endDate };
    let response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payout-by-merch-pg`,
      { headers, params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pay-in statistics:", error.message);
    throw error;
  }
}

export async function getPayoutByOrgAndPG(
  token,
  orgName,
  pg,
  startDate,
  endDate
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { orgName, pg, startDate, endDate };
    let response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/payoutByOrgAndPg`,
      { headers, params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payout statistics:", error.message);
    throw error;
  }
}
export async function getSelfUser(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(`${API_BASE_URL}/v1/admin/users/profile`, {
      headers,
    });

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function updateUser(token, formData) {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/admin/users/profile`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Update User Error:", error);
    throw error;
  }
}
export async function getPayoutProvider(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/provider/payout/provider`,
      { headers },
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function addWalletFund(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(`${API_BASE_URL}/v1/fundLoad/add`, data, {
      headers,
    });

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function fetchWalletTxns(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(`${API_BASE_URL}/v1/fundload/all`, {
      headers,
    });

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getPassbookData(token, role, userName) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const params = { role, userName };
    const response = await axios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-passbook-data`,
      { headers, params },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getProviderByOrgName(orgName) {
  try {
    let response = await axios.get(
      API_BASE_URL + `/v1/provider/org/getproviderByOrgName?orgName=${orgName}`,
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getProviderByMerchantId(merchId) {
  try {
    let response = await axios.get(
      API_BASE_URL +
      `/v1/provider/org/getproviderByMerchantId?merchId=${merchId}`,
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getDailytransactions(userId, startDate, endDate) {
  try {
    const params = { userId, startDate, endDate };
    let response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/user/dailytransactions`,
      { params }
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getMerchantDailyTransactions(
  providerId,
  startDate,
  endDate
) {
  try {
    const params = { providerId, startDate, endDate };
    let response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/transactions/provider/dailytransactions`,
      {
        params,
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getSettlementAmount(startDate, endDate) {
  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/provider-settlement-amount`,
      { params }
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function changeTxnStatus(token, order) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.post(
      `${API_BASE_URL}/v1/admin/transactions/change-txn-status`,
      order,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function sendEmailOTP(userId) {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/admin/users/send-otp/${userId}`,
    );

    return response.data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
}

export async function verifyOtp(userId, entOtp) {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/admin/users/verify-otp/${userId}`,
      { entOtp },
    );

    return response.data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
}

export async function updatePassword(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/admin/users/password`,
      data,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
}

export async function verifyUserMail(email) {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/admin/users/verify-mail`,
      { email },
    );

    return response.data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
}

export async function resetForgotPassword(userId, data) {
  data.userId = userId;

  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/admin/users/reset-forgot-password`,
      data,
    );

    return response.data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
}

export async function adminRequestFundLoad(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/fundLoad/requestFundLoad`,
      data,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function fetchAllPenddingTxns(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/fundload/all/pending`,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getUser(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(`${API_BASE_URL}/v1/admin/users`, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
export async function disablePayinPayout(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/admin/users/disable-all`,
      { ...data },
      {
        headers,
      }
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function downloadReconReport(token, startDate, endDate) {
  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/reconciliation/download-report`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDate,
          endDate,
        },
        responseType: "blob",
      }
    );

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function downloadComplaintsReport(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/complaint/download-report`,
      { headers, responseType: "blob", params },
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function penddingFundLoadUpdate(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/fundLoad/updateFundLoad`,
      data,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function fetchAllAdminFundTxns(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(`${API_BASE_URL}/v1/fundload/allAdmin`, {
      headers,
    });

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function registerAutoSwitchProvider(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/switch/create`,
      data,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function updateAutoSwitchProvider(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/switch/update`,
      data,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function deleteAutoSwitch(token, id) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.delete(
      `${API_BASE_URL}/v1/switch/delete?id=${id}`,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function viewAutoSwitch(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/switch/get-all-switches`,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function viewVpas(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/vpa-pool/get-all-vpas`,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function updateVpasLimit(token, payload) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/vpa-pool/update-limit`,
      payload,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function updateVpasPriority(token, payload) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/vpa-pool/priority`,
      payload,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function addVpa(token, payload) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/vpa-pool/priority`,
      payload,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getTransactionByField(token, field, id) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const params = { field, id };

  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-txn-by-field`,
      { headers, params },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getAllMerchnatWebhooks(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/webhooks/get-merchant-webhooks`,
      { headers },
    );
    return response;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export const updateMerchantWebhooks = async (id, payload, token) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/webhooks/update-webhooks-by-id/${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};

export async function getUserApiKeysData(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/admin/users/integrations`,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function rotateApiKey(token, userId) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/admin/users/rotate/${userId}`,
      {},
      { headers },
    );
    return response.data?.apiKey;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getMerchantIPs(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(`${API_BASE_URL}/v1/admin/users/all/ips`, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function UpdateIpStatus(token, ipWhitelistId, status) {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/admin/users/ipwhitelist/status`,
      {},
      {
        params: {
          ipWhitelistId,
          status,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function CreateNewIps(token, ip, userId,status) {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/admin/users/register-ip`,
      {
        ip,
        userId,
        status
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getSettlementReport(
  token,
  page,
  startDate = null,
  endDate = null,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const queryParams = new URLSearchParams();
  queryParams.append("page", page);
  if (startDate) queryParams.append("startDate", startDate);
  if (endDate) queryParams.append("endDate", endDate);

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/settlement/get-settlment-report?${queryParams.toString()}`,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getTotalProviderSettlement(
  token,
  page,
  startDate = null,
  endDate = null,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const queryParams = new URLSearchParams();
  queryParams.append("page", page);
  if (startDate) queryParams.append("startDate", startDate);
  if (endDate) queryParams.append("endDate", endDate);
  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/settlement/get-provider-settlement?${queryParams.toString()}`,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
}

export async function getSettlementByUTR(token, utr) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/settlement/get-settlement-by-id?utr=${utr}`,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
}

export async function downloadRolingReserveReport(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/rolling-reserve/rolling-reserve-report`,
      { headers, responseType: "blob", params },
    );

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function updateSettlementAmount(token, id, amount) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    await axios.patch(
      `${API_BASE_URL}/v1/settlement/update-settlement-amount?id=${id}&amount=${amount}`,
      {},
      { headers },
    );
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getMerchantSettlement(
  token,
  startDate = null,
  endDate = null,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const queryParams = new URLSearchParams();
  if (startDate) queryParams.append("startDate", startDate);
  if (endDate) queryParams.append("endDate", endDate);
  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/settlement/get-merchant-settlement?${queryParams.toString()}`,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
}

export async function merchantSettlementPaid(token, id, amount, remark) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    await axios.patch(
      `${API_BASE_URL}/v1/settlement/update-merchant-settlement-amount?id=${id}&amount=${amount}&remark=${remark}`,
      {},
      { headers },
    );
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
export async function downloadGenerateReports(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-report`,
      { headers, params: {} },
    );

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
export async function reportDownloadAWSBucket(path, token) {
  const headers = { Authorization: `Bearer ${token}` };

  const params = {
    path: encodeURIComponent(path),
  };

  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/download-file`,
      {
        headers,
        params,
      }
    );
    return response;
  } catch (error) {
    console.log("Error downloading file:", error.message);
    throw error;
  }
}
export async function getActiveUsers(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-active-users`,
      {
        headers,
        params: {},
      },
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function successMuffinTransactions(token, payload) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.post(
      `${API_BASE_URL}/v1/admin/transactions/success-muffin-transactions`,
      { ...payload },
      {
        headers,
      }
    );
    return  { data: response.data, response: "Success" };
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getAllPenddingSettlement(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/fundload/all/pending-settlement`,
      {
        headers,
      },
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
export async function approvePenddingSettlement(token, data) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/settlement/aproveSettlement`,
      data,
      {
        headers,
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getMerchantChargeback(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/reconciliation/get-merchant-chargeback-report`,
      {
        headers,
        params: {},
      },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function downloadProviderReport(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/settlement/download-settlement-report?startDate=${startDate}&endDate=${endDate}`,
      { headers, responseType: "blob" },
    );

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
export async function getBlockKeyword(page, keyword) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      API_BASE_URL +
      `/block-keyword/get-all-keyword?page=${page}&keyword=${keyword}`,
      {
        headers,
      },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function addBlockKeyword(keyword) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(
      API_BASE_URL + `/block-keyword`,
      {
        keyword,
      },
      {
        headers,
      },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function deleteBlockKeyword(id) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.delete(API_BASE_URL + `/block-keyword/${id}`, {
      headers,
    });

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getNotFoundWebhooks(page, orderId, utr) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      API_BASE_URL +
      `/not-found-webhook/get-all?page=${page}&orderId=${orderId}&utr=${utr}`,
      {
        headers,
      },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getAvilableBalance(token, userId) { //! Not in use in prod
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/admin/transactions/avilable-balance?userId=${userId}`,
      { headers },
    );
    console.log("Available balance response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Available balance error:", error.message);
    throw error;
  }
}
export async function paidNotFoundWebhooks(id) {
  try {
    const response = await axios.patch(
      API_BASE_URL + `/not-found-webhook/${id}/paid`,
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function GetAllNotifications(role) {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/notifications/get-all-notification?role=${role}`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}


export async function GetAllActivities() {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/notifications/get-all-activity`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}


  export async function GetAllNotificationsWithType(type,page) {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/notifications/get-notifications?type=${type}&page=${page}`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function GetUnreadNotifications() {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/notifications/get-unread-notification`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function GetReadNotifications() {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/notifications/get-read-notification`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function ReadNotifications(id) {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/notifications/${id}/read`,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fraudDecdectedNotification(data) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(
      API_BASE_URL + `/notifications/fraud-notifications`,
      data,
      {
        headers,
      }
    );
    console.log(response, "errrrrrrrrr");
    return response.data; // Return the response data if needed
  } catch (error) {
    console.log(error.message);
    throw error; // Re-throw the error if needed
  }
}
export async function getAvilableBalanceName(userId) {
  try {
    const params = { userId: userId };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-admin-balance`,
      {
        params,
      }
    );
    console.log("Available balance response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Available balance error:", error.message);
    throw error;
  }
}
export async function addVpaTransfer(data) {
  try {
    const response = await axios.post(API_BASE_URL + `/vpa-transfer`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getAlllRoles(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/admin/users/role/all-roles`,
      { headers },
    );
    // console.log("all Roles", response)
    return response;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getTransactionByUtr(token, utrInputString) {
  const utrArray = utrInputString
    .split(",")
    .map((u) => u.trim())
    .filter(Boolean);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.post(
      `${API_BASE_URL}/v1/admin/transactions/get-txn-by-utr`,
      { utrs: utrArray },
      { headers },
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching UTR data:", err.message);
    throw err;
  }
}

export async function getInvoiceNumbers(token, utrsArray) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.post(
      API_BASE_URL + `/v1/admin/transactions/get-multiple-invoice-numbers`,
      { utrs: utrsArray },
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function isChargebackExists(orderIds, token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/reconciliation/is-chargeback-exists`,
      {
        headers,
        params: {
          orderIds,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
export async function getAllActiveProvider() {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/provider/providers/active-providers`,
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function updateUserPayinProvider(providerId, users, token) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/admin/users/payin/updateProvider`,
      { providerId, users },
      { headers },
    );
    return response.data;
  } catch (err) {
    console.error("Error updating user payin provider:", err.message);
    throw err;
  }
}

export async function updateUserPayoutProvider(providerId, users, token) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/v1/admin/users/payout/updateProvider`,
      { providerId, users },
      { headers },
    );
    return response.data;
  } catch (err) {
    console.error("Error updating user payout provider:", err.message);
    throw err;
  }
}

export async function getAllUsersForProvoider(token, page, status) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/admin/users/provider/getUsers?page=${page}&status=${status}`,
      { headers },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getProviderSuccessRate(min) {
  try {
    const params = { min };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-provider-success-rate`,
      { params }
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getUserSuccessRate(min) {
  try {
    const params = { min };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-user-success-rate`,
      {
        params,
      }
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function providerPayoutBalnce() {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/provider/fetch-provider-balance`,
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getProviderWalletReport(token, page) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const queryParams = new URLSearchParams();
  queryParams.append("page", page);

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/wallet/get-provider-wallet-report?${queryParams.toString()}`,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function uploadWalletProvider(token, formData) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    await axios.post(`${API_BASE_URL}/v1/wallet/wallet-load`, formData, {
      headers,
    });
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function ApproveWalletProvider(token, formData) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    await axios.post(
      `${API_BASE_URL}/v1/wallet/approve-load-wallet`,
      formData,
      { headers },
    );
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getProviderAvilableBalance(token, page) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const queryParams = new URLSearchParams();
  queryParams.append("page", page);

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/wallet/get-provider-avilable-balance?${queryParams.toString()}`,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function approveComplaints(token, payload) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await secureAxios.patch(
      API_BASE_URL + `/v1/admin/complaint/approve-complaint`,
      payload,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function utrVerify(token, utr) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params ={ utr };
    const response = await secureAxios.get(
      API_BASE_URL + `/v1/admin/complaint/check-complaint-utr`,
      { headers, params },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
export async function createComplaint(payload, token) {
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await secureAxios.post(
      API_BASE_URL + `/v1/admin/complaint/create-complaint`,
      payload,
      { headers, responseType: "blob" },
    );

    return response;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}


export async function getComplaintsData(
  token,
  page,
  startDate,
  endDate,
  userId,
) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const params = {
      page,
      ...(startDate !== undefined && { startDate }),
      ...(endDate !== undefined && { endDate }),
      ...(userId && { userId }),
    };

    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/complaint/get-complaints-data`,
      {
        headers,
        params,
      }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getComplaintsDashboardData(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/complaint/get-dashboard-data`,
      { headers,params },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function ClearPenddingTrancation(data) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await secureAxios.post(
      API_BASE_URL + `/v1/admin/transactions/pending-payout-txns`,
      data,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
export async function ClearPenddingUuidTrancation(data) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await secureAxios.post(
      API_BASE_URL + `/v1/admin/transactions/uuid-payout-failed`,
      data,
      { headers },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function returnPayoutIds(refId) {
  try {
    const response = await secureAxios.post(
      API_BASE_URL + `/v1/admin/transactions/return-payout-ids`,
      {
        referenceId: refId,
      }
    );
    return response;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getSummary(token, fromDate, toDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const response = await secureAxios.get(
    API_BASE_URL + `/v1/admin/transactions/summary`,
    {
      headers,
      params: { fromDate, toDate },
    }
  );
  return response;
}

export async function getSummaryData(token, params) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const response = await secureAxios.get(
    API_BASE_URL + `/v1/admin/transactions/get-summary-data`,
    {
      headers,
      params,
    }
  );
  return response;
}

export async function todayChargebackData(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/reconciliation/todays-chargeback-data`,
      { headers, params: {} }
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getWebhookRatio() {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      API_BASE_URL + `/v1/webhooks/get-webhook-ratio`,
      headers,
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
  }
}

export async function getTrackerData(payload) {
  const headers = {
    "Content-Type": "application/json",
  };
  const params = {};

  if (payload.providerId) params.providerId = payload.providerId;
  if (payload.userId) params.userId = payload.userId;
  if (payload.orderId) params.orderId = payload.orderId;

  try {
    const response = await axios.get(
      API_BASE_URL + `/v1/webhooks/get-webhooktracker-data`,
      { headers, params },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
  }
}

export async function getProvidersNames(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/provider/get-provider-name`,
      { headers }
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
export async function overallChargebackData(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/reconciliation/overall-chargeback-data-merchant`,
      { headers, params: {} }
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
export async function overallChargebackDataOrg(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/reconciliation/overall-chargeback-data-org`,
      { headers, params: {} }
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function downloadCBReport(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/reconciliation/download-report-for-compliance`,
      { headers, params, responseType: "blob" },
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getAllReseller(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/reseller/all-reseller`,
      { headers }
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function createResellerMerchants(data, token) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/reseller/create-merchants`,
      data,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getResellerMerchants(token) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const response = await axios.get(
    `${API_BASE_URL}/v1/reseller/all-reseller-merchants`,
    { headers }
  );

  return response.data;
}

export async function updateResellerMerchant(data, token) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.patch(
      API_BASE_URL + `/v1/reseller/update-reseller-merchant`,
      data,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getResellerMerchantById(resellerId, token) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/reseller/getMerchantById`,
      { id: resellerId },
      { headers }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
export async function createResellerWallet(payload, token) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/reseller/createWallet`,
      payload,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function getAllResellerWallet(token) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  // eslint-disable-next-line no-useless-catch
  try {
    const response = await axios.get(API_BASE_URL + `/v1/reseller/wallet`, {
      headers,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}
export async function getResellerWalletById(resellerId, token) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      API_BASE_URL + `/v1/reseller/reseller-wallet`,
      { id: resellerId },
      { headers }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
export async function getResellerComm(
  resellerId,
  periodStart,
  periodEnd,
  token
) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/reseller/comm?periodStart=${periodStart}&periodEnd=${periodEnd}`,
      { id: resellerId },
      { headers }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
export async function getUserLedger(id) {
  try {
    const params = {userId: id };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-user-ledger`,
      { params }
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}


export async function pendingPayoutTnx(fromDate, toDate) {
  try {
    const response = await secureAxios.post(
      `${API_BASE_URL}/v1/admin/transactions/get-pending-payout-txns`,
      {
        fromDate,
        toDate,
      }
    );

    return response.data;
  } catch (err) {
    console.error("getPendingPayoutSummary:", err.message);
    throw err;
  }
}

export async function downloadPendingPayoutTxns(payload) {
  try {
    const response = await secureAxios.post(
      `${API_BASE_URL}/v1/admin/transactions/download-pending-payout-txns`,
      payload
    );

    return response.data;
  } catch (err) {
    console.error("downloadPendingPayoutTxns:", err.message);
    throw err;
  }
}


export async function getTransactionSummaryPending(fromDate, toDate) {
  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/summary-pending`,
      {
        params: { fromDate, toDate }
      }
    );

    return response.data;
  } catch (err) {
    console.error("getTransactionSummaryPending:", err.message);
    throw err;
  }
}


export async function getSummaryPendingData(params) {
  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-summary-pending-data`,
      {
        params
      }
    );

    return response.data;
  } catch (err) {
    console.error("getSummaryPendingData:", err.message);
    throw err;
  }
}

export async function getPayoutPendingSummary(params) {
  try {
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-payout-pending-summary`,
      {
        params
      }
    );

    return response.data;
  } catch (err) {
    console.error("getPayoutPendingSummary:", err.message);
    throw err;
  }
}

export async function uploadFailCsv(file) {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await secureAxios.post(
      `${API_BASE_URL}/v1/admin/transactions/upload-fail-csv`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (err) {
    console.error("uploadFailCsv:", err.message);
    throw err;
  }
}

export async function retryCallbackCsv(file) {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await secureAxios.post(
      `${API_BASE_URL}/v1/admin/transactions/retry-callback`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (err) {
    console.error("retryCallbackCsv:", err.message);
    throw err;
  }
}
export async function getUserPayoutSuccessRate(min) {
  try {
    const params = { min };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/get-payout-user-success-rate`,
      {
        params,
      }
    );
    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getMuffinAmount(payload) {
  try {
    const response = await secureAxios.post(
      `${API_BASE_URL}/v1/admin/transactions/get-muffin-amount`,
      payload
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}

export async function getBerleenUploadData(token, startDate, endDate) {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const params = { startDate, endDate };
    const response = await secureAxios.get(
      `${API_BASE_URL}/v1/admin/transactions/payin-upload`,
      { headers,params },
    );

    return response.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
export async function getProviderTrackingSummary(
  page,
  search,
) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.get(
      API_BASE_URL +
        `/provider-tracking-summary/all?page=${page}&search=${search}`,
      {
        headers,
      },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function updateProviderTrackingStatus(
  id,
  payload,
) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.put(
      API_BASE_URL +
        `/provider-tracking-summary/update/${id}`,
      payload,
      {
        headers,
      },
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

export async function addProviderTrackingSession(
  id,
  payload,
) {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(
      API_BASE_URL +
        `/provider-tracking-summary/add-session/${id}`,
      payload,
      {
        headers,
      }
    );

    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}
export const updateProviderTrackingSession =
  async (id, payload) => {
    const response =
      await axios.put(
        `${API_BASE_URL}/provider-tracking-summary/update-session/${id}`,
        payload,
      );

    return response.data;
  };

export async function createProviderTrackingSummary(
  payload,
) {
  const headers = {
    "Content-Type":
      "application/json",
  };

  try {
    const response =
      await axios.post(
        `${API_BASE_URL}/provider-tracking-summary/create`,
        payload,
        {
          headers,
        },
      );

    return response.data;
  } catch (error) {
    console.log(
      error?.response?.data ||
        error.message,
    );

    throw error;
  }
}